import { Vector3 } from '../../shim/three';

export const transformVertices = (vertices, matrix) => {
    const result = [];
    const p = new Vector3();

    for (let i = 0; i < vertices.length; i += 3) {
        const x = vertices[i];
        const y = vertices[i + 1];
        const z = vertices[i + 2];

        p.set(x, y, z);
        p.applyMatrix4(matrix);
        result.push(p.x, p.y, p.z);
    }
    return result;
};
